import { ChevronLeftIcon } from '@heroicons/react/solid';
import { NextSeo } from 'next-seo';
import Button from '../Button';

import { useRouter } from 'next/router';

export default function PageLayout({
  children,
  title,
  description = null,
  variant,
  back = null,
  creator_photo,
  creator_name,
  showTitleOnMobile = false,
  og = null,
}) {
  const router = useRouter();
  return (
    <>
      <head>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@typeshare_co" />
        <meta
          name="twitter:title"
          content="Typeshare | Everything you need to start writing online."
        />
        <meta
          name="twitter:description"
          content={
            'Templates so you never stare at a blank page again. One-click publishing to millions of readers. Analytics to track performance.'
          }
        />
        <meta name="twitter:creator" content="@samjshore" />
        <meta
          name="twitter:image"
          content={`https://typeshare.co${og ? og : '/ts2-og.png'}`}
        />
      </head>
      <NextSeo
        title={title}
        titleTemplate={'%s | Typeshare'}
        description={
          description
            ? description
            : 'Templates so you never stare at a blank page again. One-click publishing to millions of readers. Analytics to track performance.'
        }
        additionalLinkTags={[
          {
            rel: 'icon',
            href: '/favicon.ico',
          },
        ]}
        openGraph={{
          type: 'website',
          title: title
            ? title
            : 'Typeshare | Everything you need to start writing online.',
          description: description
            ? description
            : 'Templates so you never stare at a blank page again. One-click publishing to millions of readers. Analytics to track performance.',
          url: `https://typeshare.co/`,
          images: [
            {
              url: og ? og : '/ts2-og.png',
              width: 1200,
              height: 630,
              alt: 'Og Image Alt',
            },
          ],
        }}
      />

      <div className="mx-auto flex w-full max-w-screen-xl flex-col space-y-8 p-4 pt-8 md:p-12 md:pt-12">
        <div
          className={'flex w-full flex-col items-start justify-start space-y-8'}
        >
          <div className="sticky top-0 z-20 flex w-full flex-col items-center justify-center space-y-0 bg-gray-50 pb-4 md:relative md:top-auto md:bg-transparent md:px-0 md:pb-0">
            <div className={'flex w-full flex-col md:space-y-2'}>
              {variant === 'lg' ? (
                <div className="flex w-full flex-row rounded-xl bg-gray-200 bg-opacity-50 p-12">
                  <div className="flex flex-col space-y-1">
                    <h1 className="hidden text-3xl font-semibold tracking-tight md:flex">
                      {title}
                    </h1>
                    <p className="text-sm text-gray-500">{description}</p>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col">
                  {back && (
                    <div className="mb-4">
                      <Button
                        click={() => router.push(back)}
                        size={'mini'}
                        variant={'outline'}
                        prefix={
                          <ChevronLeftIcon className="-mr-2.5 -ml-1 h-[18px] w-[18px]" />
                        }
                      >
                        Back
                      </Button>
                    </div>
                  )}
                  <h1
                    className={`text-3xl font-semibold tracking-tight ${
                      showTitleOnMobile ? 'flex' : 'hidden md:flex'
                    } mb-1`}
                  >
                    {title}
                  </h1>
                  <p className="text-sm font-medium tracking-tightish text-gray-700">
                    {description}
                  </p>
                </div>
              )}

              <div className="w-full">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
